module.exports = __webpack_public_path__ + "static/media/icon2.bf16fd68.png";